import { PdfTemplateConfiguration } from "../../context/PdfTemplateConfigurationContext";
import "../fonts.css";
import { PdfTemplateType } from "../document-template.types";
import parse from "html-react-parser";
import { getConfig } from "../../context/util";
import { OrganizationsImg } from "./organizations-img.component";
import { getRtfWidth, replacePdfPlaceholders } from "../utils";
import {
	ClientEntityType,
	JobDocumentEntityType,
} from "@/lib/supabase/supabaseTypes";
import { PDFConfigPlaceholder } from "../../types/enums";
import { useCentralStore } from "../../store/Central";
import { resolveRegionKind } from "../../lib/utils/region-utils";

export const PdfFooter = ({
	pdfTemplateConfiguration,
	templateType,
	jobDocument,
	client,
	currencyConverterValues,
}: {
	pdfTemplateConfiguration: PdfTemplateConfiguration;
	templateType: PdfTemplateType;
	jobDocument?: JobDocumentEntityType;
	client?: ClientEntityType | null;
	currencyConverterValues?: Record<string, string>;
}) => {
	const generalConfig = pdfTemplateConfiguration.general;
	const pdfConfig = pdfTemplateConfiguration?.[templateType] || {};

	const config = getConfig(pdfConfig, generalConfig);

	const activatedRegions = useCentralStore((state) => state.activatedRegions);
	const organization = useCentralStore((state) => state.organization);
	const region = resolveRegionKind(
		client ?? null,
		organization,
		activatedRegions
	);
	// Region-specific comment overrides the document default; both support placeholders.
	const comment =
		(region != null
			? pdfConfig.commentTextByRegion?.[region]
			: undefined) ?? pdfConfig.commentText;

	const commentHtml = replacePdfPlaceholders(comment?.text ?? "", {
		[PDFConfigPlaceholder.EORI]: client?.eori_number ?? "",
		...(currencyConverterValues ?? {}),
	});

	const fontSize = {
		sm: "6pt",
		md: "8pt",
		lg: "10pt",
	};

	const isJobDocument =
		jobDocument !== undefined &&
		(templateType === PdfTemplateType.KOSTENVORANSCHLAG ||
			templateType === PdfTemplateType.LIEFERSCHEIN ||
			templateType === PdfTemplateType.GUTSCHRIFT);

	return (
		<div>
			<div
				aria-label="Kommentar"
				style={{
					width: getRtfWidth(comment?.width),
					paddingTop: "5mm",
					fontSize: fontSize[generalConfig.size ?? "lg"],
					textAlign: generalConfig.commentAlignment,
					whiteSpace: "pre-wrap",
					overflowX: "hidden",
				}}
			>
				{parse(commentHtml)}
			</div>
			<div
				aria-label="Fusszeile"
				style={{
					width: getRtfWidth(pdfConfig.footerText.width),
					paddingTop: "5mm",
					fontSize: fontSize[generalConfig.size ?? "lg"],
					textAlign: generalConfig.footerAlignment,
					whiteSpace: "pre-wrap",
					overflowX: "hidden",
				}}
			>
				{parse(pdfConfig.footerText.text ?? "")}
			</div>
			{isJobDocument && jobDocument.note && (
				<div
					aria-label="Hinweis"
					style={{
						paddingTop: "5mm",
						fontSize: fontSize[generalConfig.size ?? "lg"],
						display: "flex",
					}}
				>
					<b style={{ marginRight: "4px" }}>Hinweis:</b>
					<div style={{ textAlign: "center" }}>
						{jobDocument.note}
					</div>
				</div>
			)}
		</div>
	);
};
